const funcs = {
  formatPhoneNumber: function (val) {
    var cleaned = ('' + val).replace(/\D/g, '')
    if (cleaned.startsWith(+1)) {
      cleaned = cleaned.replace(+1, '')
    }
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return val
  },
  formatNumberToCurrency: function (price) {
    return price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
  },
}
export default funcs



// WEBPACK FOOTER //
// ./src/utils/formatting.js